import { render, staticRenderFns } from "./cust-detail.vue?vue&type=template&id=0990d3fe&scoped=true&"
import script from "./cust-detail.vue?vue&type=script&lang=js&"
export * from "./cust-detail.vue?vue&type=script&lang=js&"
import style0 from "./cust-detail.vue?vue&type=style&index=0&id=0990d3fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0990d3fe",
  null
  
)

export default component.exports